export const DEVICE_TYPES = [
  'weight_scale',
  'bp_monitor',
  'pulse_oximeter',
  'digital_thermometer',
  'infrared_thermometer',
  'wearable_thermometer',
  'glucometer',
  'fetal_doppler',
];

export const DEVICE_LABELS = {
  weight_scale: 'Weight Scale',
  bp_monitor: 'BP Monitor',
  pulse_oximeter: 'Pulse Oximeter',
  digital_thermometer: 'Digital Thermometer',
  infrared_thermometer: 'Infrared Thermometer',
  wearable_thermometer: 'Wearable Thermometer',
  glucometer: 'Glucometer',
  fetal_doppler: 'Fetal Doppler',
};

export const PARTNER_STATUSES = ['active', 'suspended', 'inactive'];
export const BILLING_STATUSES = ['trial', 'active', 'past_due', 'cancelled'];
